import { render, staticRenderFns } from "./_CreateAction.vue?vue&type=template&id=fbfbf920&scoped=true&"
import script from "./_CreateAction.vue?vue&type=script&lang=ts&"
export * from "./_CreateAction.vue?vue&type=script&lang=ts&"
import style0 from "./_CreateAction.vue?vue&type=style&index=0&id=fbfbf920&lang=scss&scoped=true&"
import style1 from "./_CreateAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfbf920",
  null
  
)

export default component.exports